module.exports = __webpack_public_path__ + "static/media/scrum3.75957cf5.png";